import React, { Component } from 'react'
import Button from '@material-ui/core/Button'

export class Scrapper extends Component {
  Scrap = () => {
    let Language2 = ''
    let PresentParticiple = ''
    let PastParticiple = ''
    let Present = []
    let Past = []
    let Past1 = []
    let Conditional = []
    let Future = []
    let Imperativ = []
    let Imperativ1 = []
    let Present_Subjunctive = []

    // var ScrapperCall = this.props.ScrapperCall;
    //console.log(ScrapperCall);

    const cheerio = require('cheerio')
    const request = require('request')

    request(
      {
        method: 'GET',
        //url: 'https://www.linguasorb.com/french/verbs/conjugation/abonnir
        //  url:"https://www.linguasorb.com/french/verbs/conjugation/" + this.props.SearchedWord
        url:
          'https://uplifted-stream-263318.ey.r.appspot.com/https://www.linguasorb.com/french/verbs/conjugation/' +
          this.props.SearchedWord,
      },
      (err, res, body) => {
        if (err) return console.error(err)

        let $ = cheerio.load(body)

        Language2 = $('small').text()

        $('.nominal span.vReg').each(function (i, e) {
          if (i == 1) PresentParticiple = $(this).text()
          if (i == 0) PastParticiple = $(this).text()
        })
        // $('.nominal span.vIrreg').each(function (i, e) {
        //   if(i==1)
        //     PresentParticiple = $(this).text();
        //   if(i==0)
        //     PastParticiple= $(this).text();
        // });

        this.props.ScrapperCall(
          Language2,
          PresentParticiple,
          PastParticiple,
          Present,
          Past,
          Past1,
          Conditional,
          Future,
          Imperativ,
          Imperativ1,
          Present_Subjunctive
        )
      }
    )

    request(
      {
        method: 'GET',
        //url: 'https://www.spanishdict.com/conjugate/'+this.props.SearchedWord
        // url:
        //   "http://conjugator.reverso.net/conjugation-french-verb-" +
        //   this.props.SearchedWord +
        //   ".html",
        url:
          'https://uplifted-stream-263318.ey.r.appspot.com/http://conjugator.reverso.net/conjugation-german-verb-' +
          this.props.SearchedWord +
          '.html',
      },
      (err, res, body) => {
        if (err) return console.error(err)
        let $ = cheerio.load(body)

        // $(".conj-basic-word").each(function (i, e) {
        //   if (i == 0) PresentParticiple = $(this).text();
        //   if (i == 1) PastParticiple = $(this).text();
        // });

        //  $('#ch_divConjugatorHeader').find("a").each(function (i, e) {
        //   //  alert($(this).text());

        //  });
        Imperativ[0] = '-'
        Imperativ[1] = '-'
        Imperativ[2] = '-'
        Imperativ[3] = '-'
        Imperativ[4] = '-'
        Imperativ[5] = '-'

        $('.verb-forms-wrap h2 a').each(function (i, e) {
          console.log($(this).text())
          if ($(this).text() != undefined) {
            if (i == 1) PresentParticiple = $(this).text()
            else if (i == 2) PastParticiple = $(this).text()
          }
        })

        $('.blue-box-wrap li').each(function (i, e) {
          if ($(this).text() != undefined) {
            if (i == 0) Present[0] = $(this).text()
            else if (i == 1) Present[1] = $(this).text()
            else if (i == 2) Present[2] = $(this).text()
            else if (i == 3) Present[3] = $(this).text()
            else if (i == 4) Present[4] = $(this).text()
            else if (i == 5) Present[5] = $(this).text()
            // else if(i==6)
            // Present[6] = $(this).text();
            else if (i == 18) Past[0] = $(this).text()
            else if (i == 19) Past[1] = $(this).text()
            else if (i == 20) Past[2] = $(this).text()
            else if (i == 21) Past[3] = $(this).text()
            else if (i == 22) Past[4] = $(this).text()
            else if (i == 23) Past[5] = $(this).text()
            else if (i == 6) Past1[0] = $(this).text()
            else if (i == 7) Past1[1] = $(this).text()
            else if (i == 8) Past1[2] = $(this).text()
            else if (i == 9) Past1[3] = $(this).text()
            else if (i == 10) Past1[4] = $(this).text()
            else if (i == 11) Past1[5] = $(this).text()
            else if (i == 12) Future[0] = $(this).text()
            else if (i == 13) Future[1] = $(this).text()
            else if (i == 14) Future[2] = $(this).text()
            else if (i == 15) Future[3] = $(this).text()
            else if (i == 16) Future[4] = $(this).text()
            else if (i == 17) Future[5] = $(this).text()
            else if (i == 72) Conditional[0] = $(this).text()
            else if (i == 73) Conditional[1] = $(this).text()
            else if (i == 74) Conditional[2] = $(this).text()
            else if (i == 75) Conditional[3] = $(this).text()
            else if (i == 76) Conditional[4] = $(this).text()
            else if (i == 77) Conditional[5] = $(this).text()
            else if (i == 90) Imperativ[1] = $(this).text()
            else if (i == 91) Imperativ[3] = $(this).text()
            else if (i == 92) Imperativ[4] = $(this).text()
            else if (i == 93) Imperativ[5] = $(this).text()
            else if (i == 48) Present_Subjunctive[0] = $(this).text()
            else if (i == 49) Present_Subjunctive[1] = $(this).text()
            else if (i == 50) Present_Subjunctive[2] = $(this).text()
            else if (i == 51) Present_Subjunctive[3] = $(this).text()
            else if (i == 52) Present_Subjunctive[4] = $(this).text()
            else if (i == 53) Present_Subjunctive[5] = $(this).text()
          }
        })

        this.props.ScrapperCall(
          Language2,
          PresentParticiple,
          PastParticiple,
          Present,
          Past,
          Past1,
          Conditional,
          Future,
          Imperativ,
          Imperativ1,
          Present_Subjunctive
        )
      }
    )
  }

  render() {
    return (
      <div>
        <Button
          onClick={() => this.Scrap()}
          variant="contained"
          color="secondary"
        >
          Scrap
        </Button>
      </div>
    )
  }
}

export default Scrapper
